// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App';
import router from './router';
import MintUI from 'mint-ui';
import 'mint-ui/lib/style.css';
import store from './store/index.js';
import axios from "axios";
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
import urlParams from "./api/urlParams";

import ElementLocale from 'element-ui/lib/locale'
import en from './language/en'
import zh from './language/zh'
import vi from './language/vi'
import th from './language/th'
import VueI18n from 'vue-i18n'
Vue.use(MintUI)
// import vConsole from '@/utils/vconsole.js'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(VueI18n);
console.log(urlParams('locale') || 'zh')
const i18n = new VueI18n({
    locale: urlParams('locale') || 'zh',
    messages: {
        zh,
        en,
        vi,
        th
    }
})

Vue.use(ElementUI)

/* eslint-disable no-new */

ElementLocale.i18n((key, value) => i18n.t(key, value))
window.vm = new Vue({
    el: '#app',
    router,
    i18n,
    store: store,
    components: { App },
    template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js